jQuery(function ($) {
	// OPTIKKOLIIKEHAKU
	if ($("#optikkoform")) {

		$("#optikkoform_hakusana").on("keydown", function (e) {
			if (e.which === 13) {
				e.preventDefault();
				return false;
			}
		});
	}
	// OPTIKKOLIIKEHAKU
});